import { useEffect, useRef } from 'react';
import { initializePaddle, type Paddle } from '@paddle/paddle-js';

const PADDLE_CLIENT_TOKEN = import.meta.env.VITE_PADDLE_CLIENT_TOKEN || '';
const PADDLE_ENVIRONMENT = import.meta.env.VITE_PADDLE_ENVIRONMENT === 'production' ? 'production' : 'sandbox';

let paddleInstance: Paddle | null = null;

export function usePaddle() {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !PADDLE_CLIENT_TOKEN) return;
    initializedRef.current = true;

    initializePaddle({
      environment: PADDLE_ENVIRONMENT,
      token: PADDLE_CLIENT_TOKEN,
    }).then((paddle) => {
      paddleInstance = paddle ?? null;
    });
  }, []);

  return paddleInstance;
}

export function getPaddleInstance(): Paddle | null {
  return paddleInstance;
}
